export const generateCages = (study_id: string | null = null, num = 0, startIndex = 0) => {
  const result: Array<{ study_id: string | null; name: string }> = [];
  for (let index = 0; index < num; index++) {
    result[index] = {
      study_id,
      name: `Cage ${startIndex + index + 1}`,
    };
  }
  return result;
};
